// react
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// context hooks
import useAsp from 'hooks/useAps';

const AffilicodeTag = () => {
  const { isThanks } = useAsp();
  const { pathname } = useLocation();
  useEffect(() => {
    const scriptId = 'affilicode';
    const isExsistScript = document.getElementById(scriptId);
    if (!!isExsistScript) isExsistScript.remove();
    const script = document.createElement('script');
    script.id = scriptId;
    script.innerHTML = isThanks
      ? `
      var _CIDN = "cid";
      var _PMTN = "pid";
      var _param = location.search.substring(1).split("&");
      var _ulp = "", _ulcid = "";
      for(var i = 0; _param[i]; i++){ var kv = _param[i].split("="); if(kv[0] == _PMTN && kv[1].length > 1){ _ulp = kv[1]; } if(kv[0] == _CIDN && kv[1].length > 1){ _ulcid = kv[1]; }}
      if(_ulp && _ulcid){ document.cookie = "CL_" + _ulp + "=" + decodeURIComponent(_ulcid) + "; expires=" + new Date(new Date().getTime() + (2592000 * 1000)).toUTCString() + "; path=/;"; }
      `
      : `
      var _CIDN = "cid";
      var _PMTN = "p";
      var _LPTU = "./";
      var _param = location.search.substring(1).split("&");
      var _ulp = "", _ulcid = "";
      for(var i = 0; _param[i]; i++){ var kv = _param[i].split("="); if(kv[0] == _PMTN && kv[1].length > 1){ _ulp = kv[1]; } if(kv[0] == _CIDN && kv[1].length > 1){ _ulcid = kv[1]; }}
      if(_ulp && _ulcid){ _xhr = new XMLHttpRequest(); _xhr.open("GET", _LPTU + "lptag.php?p=" + _ulp + "&cid=" + _ulcid); _xhr.send(); localStorage.setItem("CL_" + _ulp, _ulcid); }
      `;
    document.body.appendChild(script);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  return <></>;
};

export default AffilicodeTag;
